import { isNil, values } from "ramda";
import { isEmptyArray } from "ramda-adjunct";
import { FieldPath, FieldValues, UseControllerReturn } from "react-hook-form";
import { MuiControllerObject } from "./types";

const staticEmptyArray: string[] = [];

/**
 * Adapt Controller (useController return value) to be compatible with MUI components
 */
export const toMuiFormat = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  controller: UseControllerReturn<TFieldValues, TName>,
  required?: boolean,
  disabled?: boolean,
  readOnly?: boolean,
  disableAsReadOnly?: boolean
): MuiControllerObject<TFieldValues, TName> => {
  const { field, fieldState, formState } = controller;
  const { ref, ...fieldProps } = field;

  const errorMessages = values(fieldState.error?.types ?? {}) as string[];
  return {
    field: {
      inputRef: ref,
      error: !isNil(fieldState.error),
      errorMessage: isEmptyArray(errorMessages) ? staticEmptyArray : errorMessages, // Optimisation to get same empty array for dependecy resolution
      required,
      ...fieldProps,
      ...(disableAsReadOnly
        ? { disabled: false, readOnly: disabled ?? field.disabled }
        : { disabled: disabled ?? field.disabled, readOnly: readOnly }),
    },
    fieldState,
    formState,
  };
};
